module.exports = __webpack_public_path__ + "media/images/generic-06eae913c20f55b504a14f4014032134.svg";